<template>
  <div class="row">
    <div class="col-12">
      <h4>Thank you, your order has been placed. {{ title }}</h4>
      <h6> Order Number: {{ transId }} </h6>
      <h6> Total: ${{ total/100 }}</h6>
      <button @click="toCatalog">Go to catalog</button>
    </div>
  </div>
</template>

<script>
  import Log from 'loglevel';
  export default {
    // props: {
    //   // language: { },
    //   id: {
    //     default: ''
    //   },
    //   title: {
    //     default: 'Transaction Succeeded'
    //   }
    // },
    computed: {
      title() { return (this.$store.getters.payment["title"] || ''); },
      message() { return this.msg; },
      total() { return this.$store.getters.payment["amount"] || ''; },
      transId() {
        return this.$store.getters.payment["id"];
      },
    },
    data() {
      return {}
    },
    methods: {
      toCatalog() {
        this.$router.push({ name: 'catalog', params: this.$route.params });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Transaction.vue?269d77d2